var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_setup.id_container_grafico}})
}
var staticRenderFns = []

export { render, staticRenderFns }